<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-dollar-sign"></i></span>{{ 'BillSearch.Header' | translate}}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [(selected)]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="grid formgrid p-fluid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{
                  "BillSearch.Form.CarrierPaymentBy" | translate
                }}</label>
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="carrierPaymentByOptions"
                [showClear]="true"
                [disabled]="isForwarder"
                formControlName="carrierPaymentBy"
              ></p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ "BillSearch.Form.BillCorp" | translate }}</label>
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate}}"
                [options]="orgIdOptions"
                [showClear]="true"
                formControlName="billCorp"
              ></p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ "BillSearch.Form.InOutKey" | translate }}</label>
                <p-chips
                formControlName="billingNoList"
                separator=","
                (onAdd)="chipsAdd($event, 'billingNoList')">
                </p-chips>
            </div>


            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="grid">
                <div class="col-12 md:col-8">
                  <label>
                    <p-dropdown appendTo="body" [options]="billDateOptions" [virtualScroll]="true"
                      formControlName="billDateType"></p-dropdown>
                  </label>
                </div>
                <div class="col-12">
                  <laas-calendar #billDate [enableMaxDateIsToday]="false" [showRangeMode]="true" [showStartMode]="true"
                    [isH3Title]="true" [monthRange]="4" (onDateChange)="dateOnChange($event,'billDate')">
                  </laas-calendar>
                </div>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-4 mb-3 mt-3">
              <label>{{ 'BillSearch.Form.InOutType' | translate}}</label>
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="inOutTypeOptions"
                [showClear]="true"
                [itemSize]="30"
                [virtualScroll]="true"
                formControlName="inOutType"
              ></p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3 mt-3">
              <label>{{ "BillSearch.Form.GUINo" | translate }}</label>
              <p-chips
                formControlName="guiNo"
                separator=","
                (onAdd)="chipsAdd($event, 'guiNo')"
              ></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.AccountCode' | translate}}</label>
              <p-dropdown
              [filter]="true"
              placeholder="{{ 'Common.DropDown.Select' | translate}}"
              [options]="flowBillTypeOptions"
              [showClear]="true"
              formControlName="accountCode"
            ></p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'NoEvidenceCheck.Form.Status' | translate}}</label>
              <p-multiSelect
              [filter]="true"
              placeholder="{{ 'Common.DropDown.Select' | translate}}"
              [options]="statusOptions"
              formControlName="billingStatusList"
              ></p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.ExpressBill' | translate}}</label>
              <p-chips formControlName="expressBill" separator="," (onAdd)="chipsAdd($event, 'expressBill')"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.DoNo' | translate}}</label>
              <p-chips formControlName="doNo" separator="," (onAdd)="chipsAdd($event, 'doNo')"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.AdNo' | translate}}</label>
              <p-chips formControlName="adNo" separator="," (onAdd)="chipsAdd($event, 'adNo')"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.GUIId' | translate}}</label>
              <p-chips formControlName="guiId" separator="," (onAdd)="chipsAdd($event, 'guiId')"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.UploadBatchNo' | translate}}</label>
              <p-chips formControlName="uploadBatchNo" separator="," (onAdd)="chipsAdd($event, 'uploadBatchNo')"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.Forwarder' | translate}}</label>
              <p-dropdown
              [filter]="true"
              placeholder="{{ 'Common.DropDown.Select' | translate}}"
              [options]="carrierPaymentByOptions"
              [showClear]="true"
              formControlName="billShipper"
            ></p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.DocNo' | translate}}</label>
              <input type="text" pInputText formControlName="docNo" />
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.DiffAmount' | translate}}</label>
              <div class="formgrid grid">
                <div class="col">
                  <p-inputNumber
                    mode="decimal"
                    [minFractionDigits]="4"
                    formControlName="diffAmountStart"
                  ></p-inputNumber>
                </div>
                <div class="mt-2">~</div>
                <div class="col">
                  <p-inputNumber
                    mode="decimal"
                    [minFractionDigits]="4"
                    formControlName="diffAmountEnd"
                  ></p-inputNumber>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.DiffRatio' | translate}}</label>
              <div class="formgrid grid">
                <div class="col">
                  <input
                    type="text"
                    pInputText
                    formControlName="diffRatioStart"
                  />
                </div>
                <div class="mt-2">~</div>
                <div class="col">
                  <input
                    type="text"
                    pInputText
                    formControlName="diffRatioEnd"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.ImportType' | translate}}</label>
              <div class="formgrid grid">
                <div class="col">
                  <p-dropdown
                  [filter]="true"
                  placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="importTypeOptions"
                  [showClear]="true"
                  [itemSize]="30"
                  [virtualScroll]="true"
                  formControlName="importType"
                ></p-dropdown>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'BillSearch.Form.Facility' | translate}}</label>
              <div class="formgrid grid">
                <div class="col">
                  <laas-facility-dropdown
                  formControlName="facilityList"
                  [isMultiple]="true"
                  [showClear]="false"
                  [showFilter]="true"
                  [defaultSelectFirst]="false"
                  [showToggleAll]="true"
                  class="limit-text-width"
                  ></laas-facility-dropdown>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ "BillSearch.Form.ConsolidationNo" | translate }}</label>
                <p-chips
                formControlName="consolidationNoList"
                separator=","
                (onAdd)="chipsAdd($event, 'consolidationNoList')">
                </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ "BillSearch.Form.ContainerNumber" | translate }}</label>
                <p-chips
                formControlName="containerNumberList"
                separator=","
                (onAdd)="chipsAdd($event, 'containerNumberList')">
                </p-chips>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate}}" (click)="searchBtnClick()"></button>
              <button pButton label="{{ 'Common.Button.Reset' | translate}}" class="p-button-secondary ml-2" (click)="resetBtnClick()"></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <p-table
    #dataTable
    [columns]="selectedColumns"
    [value]="tableValue"
    [scrollable]="true"
    scrollHeight="500px"
    [reorderableColumns]="true"
    [resizableColumns]="true"
    [totalRecords]="pageInfo.totalRecords"
    (onPage)="tablePageChange($event)"
    (onSort)="tableSort($event)"
    [rowsPerPageOptions]="this.pageDropDownList"
    [showCurrentPageReport]="true"
    [paginator]="true"
    [(first)]="first"
    [rows]="100"
    [loading]="isHeaderLoading"
    [lazy]="true"
    currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
    selectionMode="single"
    [(selection)]="selectedRow"
    dataKey="rowId"
    editMode="row"
    class="edittable"
    styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;">
    <ng-template pTemplate="caption">
      <laas-table-column-toggle
        [optionsColumn]="tableColumns"
        [dataTable]="dataTable">
      </laas-table-column-toggle>
      <button
      pButton
      *ngIf="canEditTable"
      type="button"
      label="{{ 'NoEvidenceCheck.Button.EditOrView' | translate}}"
      (click)="switchEditMode()"
      icon="fas fa-pen"
      class="p-button-warning p-button-raised ml-2"
      style="color: white"
    ></button>
      <button
        pButton
        *ngIf="canEditTable"
        type="button"
        label="{{ 'Common.Button.Save' | translate}}"
        [disabled]="!editMode"
        (click)="saveBtnClick()"
        icon="fas fa-save"
        class="p-button-raised ml-2"
      ></button>
      <button
      pButton
      *ngIf="canEditTable"
      pRipple
      label="{{ 'BillSearch.BillAdd.Header' | translate}}"
      [disabled]="editMode"
      (click)="dialogVisibleChange(true)"
      class="ml-2"
    ></button>
      <button
      pButton
      pRipple
      *ngIf="canEditTable"
      label="{{ 'Common.Button.ImportExcel' | translate }}"
      [disabled]="editMode"
      (click)="importExcelBtn()"
      class="ml-2"
    ></button>
    <button
    pButton
    pRipple
    *ngIf="canEditTable"
    label="{{ 'Common.Button.DownloadExcel' | translate }}"
    [disabled]="editMode"
    (click)="openDownloadBillView()"
    class="ml-2"
    ></button>
    <button
    pButton
    pRipple
    *ngIf="canEditTable"
    label="{{ 'Common.Button.Confirm' | translate }}"
    [disabled]="editMode"
    (click)="confirmBtnClick()"
    class="ml-2"
    ></button>
    <button
    pButton
    pRipple
    *ngIf="canEditTable"
    label="{{ 'Common.Button.Cancel' | translate }}"
    [disabled]="editMode"
    (click)="cancelBtnClick()"
    class="ml-2"
    ></button>
    <button
    pButton
    pRipple
    *ngIf="canCheckBill"
    label="單據檢核"
    (click)="showCheckModal = true"
    class="ml-2"
    ></button>


    </ng-template>

    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col style="width: 3vw" />
        <col *ngFor="let col of columns" style="width: 14.8vw" />
      </colgroup>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>
          <p-checkbox
            [(ngModel)]="headerChecked"
            [binary]="true"
            (onChange)="selectAllOrUnSelectAll($event)"
          ></p-checkbox>
        </th>
        <th
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.sort"
          *ngFor="let col of columns"
          pResizableColumn
          pReorderableColumn
        >
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template
    pTemplate="body"
    let-rowData
    let-columns="columns"
    let-rowIndex="rowIndex"
    >
    <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" style="height:40px"
        [ngClass]="{
          'row-red': rowData.diffRatio > 20 || rowData.diffRatio < -20,
          'row-yellow': (rowData.diffRatio > 10 && rowData.diffRatio <= 20) || (rowData.diffRatio < -10 && rowData.diffRatio >= -20),
          'row-blue': (rowData.diffRatio > 5 && rowData.diffRatio <= 10) || (rowData.diffRatio < -5 && rowData.diffRatio >= -10)
        }"
          (click)="onRowClick(rowData)">
      <td>
        <p-checkbox
          [value]="rowData"
          [(ngModel)]="selectedRowsWithCheckBox"
        ></p-checkbox>
      </td>
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.field">
          <p-cellEditor *ngSwitchCase="'guiNo'" class="p-fluid">
            <ng-template pTemplate="input">
              <input
                pInputText
                type="text"
                required
                [(ngModel)]="rowData[col.field]"
              />
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: "-" }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'expressBill'" class="p-fluid">
            <ng-template pTemplate="input">
              <input
                pInputText
                type="text"
                required
                [(ngModel)]="rowData[col.field]"
              />
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: "-" }}
              </div>
            </ng-template>
          </p-cellEditor>
          <p-cellEditor *ngSwitchCase="'carrierPaymentBy'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="carrierPaymentByOptions"
                [showClear]="true"
                appendTo="body"
                [itemSize]="30"
                [virtualScroll]="true"
                [(ngModel)]="rowData[col.field]"
                class="p-fluid"
              ></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping: carrierPaymentByOptions
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'guiAmount'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-inputNumber
                mode="decimal"
                [minFractionDigits]="4"
                [(ngModel)]="rowData[col.field]"
              ></p-inputNumber>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | number: "1.4-4"
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'amount'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-inputNumber
                mode="decimal"
                [minFractionDigits]="4"
                (onBlur)="amountChangeEvent(rowData)"
                [(ngModel)]="rowData[col.field]"
              ></p-inputNumber>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | number: "1.4-4"
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'businessTaxBaseAmount'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-inputNumber
                mode="decimal"
                [minFractionDigits]="4"
                [(ngModel)]="rowData[col.field]"
              ></p-inputNumber>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | number: "1.4-4"
                    | replaceNullWith: "0.00"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'accountCode'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="flowBillTypeOptions"
                [showClear]="true"
                appendTo="body"
                [itemSize]="30"
                [virtualScroll]="true"
                [(ngModel)]="rowData[col.field]"
                class="p-fluid"
              ></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping: flowBillTypeOptions
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'invoiceType'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="invoiceTypeOptions"
                [showClear]="true"
                appendTo="body"
                [itemSize]="30"
                [virtualScroll]="true"
                [(ngModel)]="rowData[col.field]"
                class="p-fluid"
              ></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping: invoiceTypeOptions
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'guiCurrency'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="currencyOptions"
                [showClear]="true"
                appendTo="body"
                [itemSize]="30"
                [virtualScroll]="true"
                (onChange)="transformLinePayAmount(rowData)"
                [(ngModel)]="rowData[col.field]"
                class="p-fluid"
              ></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping: currencyOptions
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'description'" class="p-fluid">
            <ng-template pTemplate="input">
              <input
              pInputText
              type="text"
              required
              [(ngModel)]="rowData[col.field]"
            />
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'vendorDescription'" class="p-fluid">
            <ng-template pTemplate="input">
              <input
              pInputText
              type="text"
              required
              [(ngModel)]="rowData[col.field]"
            />
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'paymentMethod'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="paymentMethodOptions"
                [showClear]="true"
                appendTo="body"
                [itemSize]="30"
                [virtualScroll]="true"
                [(ngModel)]="rowData[col.field]"
                class="p-fluid"
              ></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping: paymentMethodOptions
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'termsId'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="termsIdOptions"
                [showClear]="true"
                appendTo="body"
                [itemSize]="30"
                [virtualScroll]="true"
                [(ngModel)]="rowData[col.field]"
                class="p-fluid"
              ></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping: termsIdOptions
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'linePayCurrency'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="currencyOptions"
                [showClear]="true"
                appendTo="body"
                [itemSize]="30"
                [virtualScroll]="true"
                (onChange)="transformLinePayAmount(rowData)"
                [(ngModel)]="rowData[col.field]"
                class="p-fluid"
              ></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping: currencyOptions
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'guiDt'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-calendar
                appendTo="body"
                dateFormat="yy-mm-dd"
                [showTime]="true"
                [(ngModel)]="rowData[col.field]"
              ></p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date
                      : "yyyy-MM-dd HH:mm"
                      : this.laasSetting.facilityTimeZone
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>

          <p-cellEditor *ngSwitchCase="'dueDt'" class="p-fluid">
            <ng-template pTemplate="input">
              <p-calendar
                appendTo="body"
                dateFormat="yy-mm-dd"
                [showTime]="true"
                [(ngModel)]="rowData[col.field]"
              ></p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date
                      : "yyyy-MM-dd HH:mm"
                      : this.laasSetting.facilityTimeZone
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-template>
          </p-cellEditor>
          <ng-container *ngSwitchCase="'billCorp'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping: orgIdOptions | replaceNullWith:'-'}}</div>
          </ng-container>
          <ng-container *ngSwitchCase="'billingStatus'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping: statusOptions | replaceNullWith:'-'}}</div>
          </ng-container>
          <ng-container *ngSwitchCase="'preCurrencyCode'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping: currencyOptions | replaceNullWith:'-'}}</div>
          </ng-container>
          <ng-container *ngSwitchCase="'billType'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping: billTypeOptions | replaceNullWith:'-'}}</div>
          </ng-container>
          <ng-container *ngSwitchCase="'inOutType'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:inOutTypeOptions | replaceNullWith:'-'}}</div>
          </ng-container>
          <ng-container *ngSwitchCase="'linePayAmount'">
            <div class="overflow-text">{{ rowData[col.field] | number: "1.4-4" | replaceNullWith:'-'}}</div>
          </ng-container>
          <ng-container *ngSwitchCase="'applyAmount'">
            <div class="overflow-text">{{ rowData[col.field] | number: "1.4-4" | replaceNullWith:'0.00'}}</div>
          </ng-container>
          <ng-container *ngSwitchCase="'estimatedAmount'">
            <div class="overflow-text">{{ rowData[col.field] | number: "1.4-4" | replaceNullWith:'0.00'}}</div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <ng-container [ngSwitch]="col.dataType">
              <ng-container *ngSwitchCase="'date'">
                <div class="overflow-text">{{ rowData[col.field] | date: "yyyy-MM-dd HH:mm": this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
              </ng-container>
            </ng-container>
          </ng-container>
          <p-cellEditor *ngSwitchCase="'diffAmount'" class="p-fluid">
            <ng-template pTemplate="input">
              <input pInputText type="text" required [(ngModel)]="rowData.diffAmount" />
            </ng-template>
            <ng-template pTemplate="output">
              <div class="overflow-text">
                {{ rowData.diffAmount | replaceNullWith: "-" }}
              </div>
            </ng-template>
          </p-cellEditor>
        </ng-container>
      </td>
    </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="tableColumns.length + 1">
          {{ "Common.Table.NoData" | translate }}
        </td>
      </tr>
    </ng-template>
    </p-table>
    <div style="text-align: center" *ngIf="this.selectedRow">
      <h3>{{ "BillSearch.Text.Count" | translate }}:{{selectedRowsWithCheckBox.length}}，
        {{ "BillSearch.Text.EstimatedAmount" | translate }}:{{ this.getRowSum().estimatedAmount | number: "1.4-4" }}，
        {{ "BillSearch.Text.Amount" | translate }}:{{ this.getRowSum().amount | number: "1.4-4" }}，
        {{ "BillSearch.Text.LinePayAmount" | translate }}:{{ this.getRowSum().linePayAmount | number: "1.4-4" }}，
        {{ "BillSearch.Text.ApplyAmount" | translate }}:{{ this.getRowSum().applyAmount | number: "1.4-4" }}</h3>
    </div>
  </p-card>
  <ng-container *ngIf="isShowAddBillModel">
    <laas-bill-add
      [(visible)]="isShowAddBillModel"
      (importClick)="importdailyRate($event)"
      (visibleChange)="dialogVisibleChange($event)"
    ></laas-bill-add>
  </ng-container>

</div>

<p-dialog p-dialog header="Please Select Excel Type"
  appendTo="body"
  [(visible)]="isShowExcelModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{width: '50%'}"
  max-height="500"
  >
  <div class="formgrid mt-2">
      <div class="field grid">
          <label class="col-4">Download Excel Type</label>
          <div class="col-8">
            <p-dropdown
              appendTo="body"
              [(ngModel)]="billCodeKey"
              optionLabel="label"
              optionValue="value"
              [options]="billCodeKeyOptions"
              placeholder="{{ 'Common.DropDown.Select' | translate}}"
              styleClass="p-text-left">
            </p-dropdown>
          </div>
      </div>
  </div>
  <div class="grid mt-2">
      <div class="col text-center">
          <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}" (click)="downloadBillExcelBtn()"></button>
          <button pRipple pButton label="{{ 'Common.Button.Cancel' | translate }}" class="p-button-secondary ml-2" (click)="modalCancelBtnClick($event)"></button>
      </div>
  </div>
</p-dialog>
<p-dialog header="單據檢核"
  appendTo="body"
  [(visible)]="showCheckModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onCheckModalHide()"
  [style]="{width: '50%', minWidth: '300px', minHeight: '240px'}"
  >
  <div *ngIf="checkBillLoading" class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <div class="grid formgrid p-fluid">
      <label class="mt-2 col-4 md:col-2">單據類別</label>
      <div class="mt-2 col-8 md:col-4">
        <p-dropdown
          appendTo="body"
          [filter]="true"
          placeholder="{{ 'Common.DropDown.Select' | translate }}"
          [options]="checkBillOptions"
          [showClear]="true"
          [virtualScrollItemSize]="30"
          [virtualScroll]="true"
          [(ngModel)]="checkBillType"
        ></p-dropdown>
      </div>
      <label class="mt-2 col-4 md:col-2">檢核號碼</label>
      <div class="mt-2 col-8 md:col-4">
        <p-chips
          separator=","
          [(ngModel)]="checkBillTarget"
          [allowDuplicate]="false"
          (onAdd)="onCheckBilTargetAdd($event)"
        ></p-chips>
      </div>
  </div>
  <ng-template pTemplate="footer">
      <button pRipple pButton label="執行檢核" (click)="checkBillConfirm()"></button>
  </ng-template>
</p-dialog>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
